var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChevronLeftBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.277.5 9.5 1.68 2.946 8 9.5 14.32 8.277 15.5.5 8 8.277.5Z",
  fill: "#1A1A1A"
})));
export default SvgChevronLeftBlack;